import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ReactHtmlParser from "react-html-parser";
import { Grid, useMediaQuery } from "@material-ui/core";
import ReactPlayer from "react-player";

import styles from "./styles";

function TabPanel(props) {
  const classes = styles();

  const { children, value, index, type, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      className={classes.tabPanelStyle}
    >
      {value === index && (
        // <Box p={3}>
        <div
          className={
            type.name !== process.env.EMPRESARIAL
              ? classes.tabContainer
              : classes.tabContainerEmpresarial
          }
        >
          {children}
        </div>
        // </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  type: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

export default function TabsPlan({ sections, type }) {
  const [value, setValue] = React.useState(0);

  const classes = styles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const getVideoUrl = section => {
    let urlVideoSection = "";
    const { videos } = section;
    if (videos.length > 0) {
      urlVideoSection = videos[0].url;
    }
    return urlVideoSection;
  };

  return (
    <div className={classes.root}>
      <Tabs
        classes={{
          indicator: classes.indicator
        }}
        orientation={matches ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        // aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        {sections.map((section, index) => (
          <Tab
            key={index}
            className={classes.tabStyle}
            label={section.title}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>

      {sections.map((section, index) => (
        <TabPanel key={index} value={value} index={index} type={type}>
          <Grid
            item
            xs={12}
            md={type.name !== process.env.EMPRESARIAL ? 4 : 12}
          >
            <ReactPlayer
              className={classes.videoContainer}
              url={getVideoUrl(section)}
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    showinfo: 1,
                    origin: "http://localhost:3000/"
                  }
                }
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={type !== "Empresarial" ? 8 : 12}
            className={
              type.name !== process.env.EMPRESARIAL
                ? classes.descriptionContainer
                : classes.descriptionContainerEmpresas
            }
          >
            {ReactHtmlParser(section.description || "")}
          </Grid>
        </TabPanel>
      ))}
    </div>
  );
}

TabsPlan.propTypes = {
  sections: PropTypes.any,
  type: PropTypes.any
};
